import React, { useEffect, useMemo, useState } from 'react';

const parseFields = (text) => text.trim().split('\n').map((line) => {
  const [name, type, required, description] = line.split('|');
  return { name, type, required, description };
});

const loadDatasets = [
  { name: 'Clientes', table: 'CLIENTES', description: 'Cadastro de clientes e preferência de pagamento.', fields: parseFields(`
PES_CODI|inteiro|Sim|Identificador do cliente; chave usada em pedidos, contas e preços diferenciados.
FANTASIA|texto|Sim|Nome fantasia ou apelido comercial.
VDE_CODI|texto ou inteiro|Sim|Código do vendedor associado ao cliente.
NOME_VENDEDOR|texto|Sim|Nome do vendedor associado.
PES_NOME|texto|Sim|Nome ou razão social do cliente.
IE|texto|Sim|Inscrição estadual; envie texto vazio quando não houver.
CMUN|texto|Sim|Código IBGE do município.
PES_ENDE|texto|Sim|Logradouro.
PES_NUME|texto|Sim|Número do endereço.
PES_BAIR|texto|Sim|Bairro.
PES_CIDA|texto|Sim|Cidade.
PES_ESTA|texto|Sim|UF com duas letras.
PES_CEP|texto|Sim|CEP.
PES_FONE1|texto|Sim|Telefone principal.
PES_FONE2|texto|Sim|Telefone secundário; use texto vazio quando não houver.
PES_FONE3|texto|Sim|Terceiro telefone; use texto vazio quando não houver.
PES_EMAIL|texto|Sim|E-mail.
PES_NACI|data texto|Não|Nascimento ou fundação em DD/MM/AAAA; inválida ou ausente vira 01/01/2000.
PES_CPF|texto|Sim|CPF ou CNPJ do cliente.
PES_FJ|texto|Sim|Tipo de pessoa, normalmente F ou J.
PES_CONTATO|texto|Sim|Nome do contato.
ALIQIBSMUN|decimal|Não|Alíquota municipal de IBS; padrão 0.
IDPAGPREF|texto|Não|Código de FormaPgto.CPGTO_CODI preferido; vazio não pré-seleciona.`) },
  { name: 'Produtos', table: 'PRODUTOS', description: 'Produtos, preços, estoque e tributação.', fields: parseFields(`
COD_PROD|texto ou inteiro|Sim|Código comercial ou interno usado para localizar o produto.
UNID|texto|Sim|Unidade de venda, por exemplo UN, KG ou LT.
DESCRICAO|texto|Sim|Descrição do produto.
ANP|texto|Sim|Código ANP; use texto vazio para produto não combustível.
CEST|texto|Sim|Código CEST; use texto vazio quando não aplicável.
NCM|texto|Sim|NCM do produto.
IMPF|decimal|Sim|Percentual tributário federal legado.
IMPE|decimal|Sim|Percentual tributário estadual legado.
ESTOQUE|decimal|Sim|Quantidade ou base de estoque recebida do servidor.
ESTOQUE_ATUAL|decimal|Sim|Saldo atual disponível para venda.
PRECO_VENDA|decimal|Sim|Preço principal.
PRECO_VENDA_DESCONTO|decimal|Sim|Preço de venda com desconto.
PRECO_ATACADO|decimal|Sim|Preço de atacado.
PRECO_BALCAO|decimal|Sim|Preço de balcão.
PRECO_BALCAO_DESCONTO|decimal|Sim|Preço de balcão com desconto.
COMISSAO|decimal|Sim|Percentual de comissão.
DESCMAX|decimal|Sim|Desconto máximo permitido, conforme a regra do ERP.
VALOR_COMISSAO|decimal|Sim|Valor de comissão cadastrado.
MARCA|texto|Sim|Marca.
MODELO|texto|Sim|Modelo.
DESCONTO|decimal|Sim|Desconto padrão do produto.
CFOP|texto|Sim|CFOP padrão.
CST|texto|Sim|CST de ICMS ou CSOSN usado pelo aplicativo.
ALIQUOTA|decimal|Sim|Alíquota de ICMS.
CSTPIS|texto|Sim|CST de PIS/COFINS.
PIS|decimal|Sim|Alíquota de PIS.
COFINS|decimal|Sim|Alíquota de COFINS.
IPI|decimal|Sim|Alíquota de IPI.
ID|inteiro|Sim|Identificador principal; usado em grupos, receitas e cálculos.
GTIN|texto|Sim|GTIN, EAN ou código de barras.
MEDIO|decimal|Sim|Valor médio exibido pelo aplicativo.
STATUS|texto|Sim|Situação do produto conforme a convenção do ERP.
REMICMSRETEN|decimal|Sim|Percentual de ICMS monofásico anteriormente retido.
GRUPO|inteiro|Não|Relaciona o produto a Grupos.CODGRUPO. Use 0 quando ele não pertence a um grupo exibido.
IDRECEITA|inteiro|Não|Relaciona o produto pai a Composicao.IDRECEITA para definir itens que podem ser retirados ou fazem parte da receita.
CBENEF|texto|Sim|Código de benefício fiscal; use texto vazio quando não aplicável.
ALIQNAC|decimal|Sim|Carga tributária aproximada nacional ou federal.
ESTADUAL|decimal|Sim|Carga tributária aproximada estadual.
imagem|texto Base64|Recomendado|Nome em minúsculas. Envie sempre; use texto vazio sem imagem.
CCLASSTRIB|texto|Não|Classificação tributária de IBS/CBS; padrão texto vazio.
ALIQIBS|decimal|Não|Alíquota estadual de IBS; padrão 0.
PERC_REDUCAO_IBS|decimal|Não|Percentual de redução da alíquota de IBS; padrão 0.
PERC_REDUCAO_CBS|decimal|Não|Percentual de redução da alíquota de CBS; padrão 0.
NSABORES|texto ou inteiro|Não|Quantidade máxima de sabores selecionáveis. Pizza de dois sabores usa 2; açaí com uma opção de tamanho usa 1; produto comum usa 0.`) },
  { name: 'Grupos', table: 'TBGRUPOS', description: 'Grupos e categorias de produtos.', fields: parseFields(`
ID|inteiro|Sim|Identificador interno do registro.
CODGRUPO|inteiro|Sim|Código relacionado a Produtos.GRUPO.
DESCRICAO|texto|Sim|Nome do grupo.
MARKUP|decimal|Sim|Markup padrão do grupo.
ENVIA|texto|Sim|Indicador legado de envio ou integração.
CODUAIRANGO|texto|Sim|Código do grupo na integração UaiRango.
CODWOO|texto|Sim|Código ou indicador da integração WooCommerce.
CODCONSIDERAR|texto|Sim|Código considerado nas regras de agrupamento ou integração.`) },
  { name: 'Composicao', table: 'TBITENRECEITA', description: 'Componentes de receitas, combos ou produtos compostos.', fields: parseFields(`
ID|inteiro|Sim|Identificador do componente.
IDRECEITA|inteiro|Sim|Receita pai, relacionada a Produtos.IDRECEITA.
CODIGO|texto|Sim|GTIN do produto componente ou ingrediente; deve existir em Produtos.GTIN.
QTDE|decimal|Sim|Quantidade do componente.
OBS|texto|Sim|Instrução exibida para a composição, por exemplo PODE RETIRAR A CEBOLA.
ACRESCIMO|decimal|Sim|Valor de acréscimo do componente.`) },
  { name: 'ItensAcrescimo', table: 'TBITENSACRESCIMO', description: 'Acréscimos e adicionais vinculados aos produtos.', fields: parseFields(`
ID|inteiro|Sim|Identificador do adicional.
CODIGO|texto|Sim|GTIN do produto adicional; deve existir em Produtos.GTIN.
ACRESCIMO|decimal|Sim|Valor acrescido ao pedido.
CODPRODUTO|texto|Sim|GTIN do produto pai que oferece o adicional; deve existir em Produtos.GTIN.
IDCATEGORIA|inteiro|Sim|Identificador livre para organizar adicionais em seções no aplicativo. Não precisa existir em Grupos.
QTDE|decimal|Sim|Quantidade padrão.
MEIAPIZZA|texto|Sim|SIM permite aplicar o adicional em meia pizza; NAO aplica ao item inteiro; vazio para produtos sem essa regra.`) },
  { name: 'Opcoesdoitem', table: 'TBOPCOES', description: 'Opções de item e sabores. Respeite exatamente esta grafia.', fields: parseFields(`
ID|inteiro|Sim|Identificador da opção.
DESCRICAO|texto|Sim|Descrição da opção ou sabor.
CODPRODUTO|texto|Sim|GTIN do produto pai que oferece a opção; deve existir em Produtos.GTIN.
VALOR|decimal|Sim|Valor adicional da opção.
MPIZZA|texto|Sim|SIM identifica uma opção de sabor de pizza; NAO identifica opção normal, como tamanho do açaí.
CODOPCAO|texto|Não|GTIN do produto que representa o sabor escolhido. Para opções sem produto próprio, envie texto vazio.`) },
  { name: 'FormaPgto', table: 'CONDICAO', description: 'Formas e condições de pagamento.', fields: parseFields(`
CPGTO_CODI|inteiro|Sim|Código referenciado por Clientes.IDPAGPREF.
CPGTO_DESC|texto|Sim|Descrição apresentada ao usuário.
CPGTO_COND|texto|Sim|Classificação legada da condição.
DIAS|texto|Sim|Sequência ou regra de dias para vencimentos.
PARCELA|inteiro|Sim|Quantidade de parcelas.
CPGTO_DESCO|inteiro|Sim|Indicador legado de desconto.
CRECEBER|texto|Sim|SIM aparece no recebimento de contas; NAO aparece em venda ou pedido.
TPCARTAO|texto|Sim|Tipo ou código de cartão usado no recebimento.
CNPJ|texto|Sim|CNPJ da adquirente; use texto vazio quando não aplicável.`) },
  { name: 'Mva', table: 'TBMVA', description: 'MVA e FCP por produto e UF.', fields: parseFields(`
ID|inteiro|Sim|Identificador do registro.
UF|texto|Sim|UF de destino.
ALIQUOTA|decimal|Sim|Percentual de MVA.
IDPRODUTO|inteiro|Sim|Produto ao qual a regra se aplica.
FCP|decimal|Sim|Percentual de FCP.
FCPST|decimal|Sim|Percentual de FCP-ST.`) },
  { name: 'Empresa', table: 'TBEMPRESA', description: 'Dados cadastrais e fiscais; normalmente contém um objeto.', fields: parseFields(`
CODIGO|inteiro|Sim|Identificador da empresa.
RAZAO|texto|Sim|Razão social.
REGIME|inteiro|Sim|Código do regime tributário.
UF|texto|Sim|UF da empresa.
CPFCNPJ|texto|Sim|CPF ou CNPJ da empresa.
FANTASIA|texto|Sim|Nome fantasia.
ENDERECO|texto|Sim|Logradouro.
NUMERO|texto|Sim|Número.
BAIRRO|texto|Sim|Bairro.
CMUN|texto|Sim|Código IBGE do município.
CIDADE|texto|Sim|Cidade.
CEP|texto|Sim|CEP.
FONE|texto|Sim|Telefone.
IE|texto|Sim|Inscrição estadual.
CONSUMACAO|decimal|Não|Percentual da taxa de serviço ou consumação; padrão 0.
COUVERART|decimal|Não|Valor de couvert artístico; padrão 0.
ALIQCBS|decimal|Não|Alíquota de CBS da empresa; padrão 0.`) },
  { name: 'ContasReceber', table: 'CRECEBER', description: 'Títulos ainda em aberto dos clientes.', fields: parseFields(`
ID|inteiro|Sim|Identificador do título.
DOCUMENTO|texto|Sim|Número ou documento do título.
PES_CODI|inteiro|Sim|Cliente devedor, relacionado a Clientes.PES_CODI.
PREC_DTVCTO|data texto|Sim|Vencimento em DD/MM/AAAA.
PREC_DTEMIS|data texto|Sim|Emissão em DD/MM/AAAA.
PREC_VLRPAR|decimal|Sim|Valor da parcela.
PREC_MORADIA|decimal ou texto numérico|Sim|Encargo de mora por dia.
PREC_MULTA|decimal ou texto numérico|Sim|Multa do título.
BCO_CODI|inteiro|Sim|Código da conta ou banco.
BCO_NOME|texto|Sim|Nome da conta ou banco.`) },
  { name: 'Vendedores', table: 'VENDEDOR', description: 'Vendedores autorizados no aplicativo. Usuário e senha sempre em LETRAS MAIÚSCULAS.', fields: parseFields(`
ID|inteiro|Sim|Código do vendedor.
NOME|texto|Sim|Usuário de login do vendedor. Envie SEMPRE em LETRAS MAIÚSCULAS.
SENHA|texto|Sim|Senha usada pelo aplicativo. Envie SEMPRE em LETRAS MAIÚSCULAS; proteja transporte e armazenamento.`) },
  { name: 'Anp', table: 'TBANP', description: 'Informações ANP para produtos combustíveis.', fields: parseFields(`
ID|inteiro|Sim|Identificador do registro ANP.
CODIGO|texto|Sim|Código ANP do produto.
DESCRICAO|texto|Sim|Descrição ANP.
GLP|decimal|Sim|Percentual de GLP.
GNN|decimal|Sim|Percentual de gás natural nacional.
GNI|decimal|Sim|Percentual de gás natural importado.
CODIF|texto|Sim|Código de autorização ou identificação do combustível.
QTEMP|decimal|Sim|Quantidade vendida em temperatura ambiente.`) },
  { name: 'AliqUF', table: 'TBALIQUOTASESTADOS', description: 'Tributação por estado; envie ao menos um registro. ALIQIBS não é lido neste array.', fields: parseFields(`
ID|inteiro|Sim|Identificador do registro.
CODIGOESTADO|inteiro|Sim|Código numérico do estado no sistema de origem.
ESTADO|texto|Sim|Sigla da UF.
NOME|texto|Sim|Nome do estado.
ALIQUOTAICMS|decimal|Sim|Alíquota interna de ICMS.
IVA|decimal|Sim|IVA ou MVA geral da UF.
ICMSI|decimal|Sim|Alíquota interestadual usada pelo aplicativo.
FCP|decimal|Sim|Percentual de FCP da UF.`) },
  { name: 'PrecoDiferenciado', table: 'TBHISTORICOCLI', description: 'Preço específico por cliente e produto.', fields: parseFields(`
ID|inteiro|Sim|Identificador do registro.
CODIGO|texto|Sim|Código ou GTIN usado para localizar o produto.
VALOR|decimal|Sim|Preço diferenciado.
IDCLI|inteiro|Sim|Cliente relacionado a Clientes.PES_CODI.`) }
];

const appDatasets = [
  { name: 'Pedidos', path: 'Pedidos[]', description: 'Cabeçalho da venda e seus documentos fiscais.', fields: parseFields(`
CODIGO|conforme banco local|Aplicativo|Número interno do pedido.
ID_CLIENTE|conforme banco local|Aplicativo|Código do cliente.
ID_MOBILE_CLI|conforme banco local|Aplicativo|Código do cliente usado pelo mobile.
PES_NOME|texto|Aplicativo|Nome do cliente gravado no pedido.
ID_CPGTO_CODI|conforme banco local|Aplicativo|Forma de pagamento do pedido. Na força de vendas é a única informação de pagamento; 0 indica forma não informada. Veja “Onde vem o pagamento”.
DATA_VENDA|data/hora texto|Aplicativo|Data e hora do pedido conforme a região do aparelho.
OBS|texto|Aplicativo|Observações.
STATUS_TRANSM|conforme banco local|Aplicativo|Situação da transmissão.
DATA_TRANSMITIDO|data/hora texto|Aplicativo|Data e hora em que foi marcado como transmitido.
ITENS_OK|conforme banco local|Aplicativo|Indicador de consistência ou conclusão dos itens.
CHAVE|texto|Aplicativo|Chave da NF-e.
CHAVENFCE|texto|Aplicativo|Chave da NFC-e.
NFCE|conforme banco local|Aplicativo|Número da NFC-e.
PROTOCOLONFCE|texto|Aplicativo|Protocolo da NFC-e.
PROTOCOLONFE|texto|Aplicativo|Protocolo da NF-e.
RECIBONFCE|texto|Aplicativo|Recibo da NFC-e.
RECIBONFE|texto|Aplicativo|Recibo da NF-e.
NFCECSTAT|conforme banco local|Aplicativo|Código de status da NFC-e.
NFECSTAT|conforme banco local|Aplicativo|Código de status da NF-e.
DFE_DOCUMENTO_ID|conforme banco local|Aplicativo|Identificador do documento fiscal no backend DFe.
DFE_STATUS|texto|Aplicativo|Status do documento fiscal.
DFE_XML_PATH|texto|Aplicativo|Caminho ou localização do XML.
DFE_PDF_PATH|texto|Aplicativo|Caminho ou localização do PDF.
DFE_DATA_AUTORIZACAO|data/hora texto|Aplicativo|Data e hora de autorização.
CONTINGENCIA|conforme banco local|Aplicativo|Indicador de emissão em contingência.
CODVENDEDOR|conforme banco local|Aplicativo|Código do vendedor.
VENDEDOR|texto|Aplicativo|Nome do vendedor.
SERIE|conforme banco local|Aplicativo|Série da NFC-e.
SERIENFE|conforme banco local|Aplicativo|Série da NF-e.
NFE|conforme banco local|Aplicativo|Número da NF-e.
ASSINATURA_B64|texto Base64|Aplicativo|Assinatura do cliente em Base64.
itens|array|Aplicativo|Itens do pedido; o nome é minúsculo.
Pagamento|array|Aplicativo|Pagamentos do pedido; P maiúsculo.`) },
  { name: 'Itens', path: 'Pedidos[].itens[]', description: 'Produtos e valores de cada pedido.', fields: parseFields(`
CODIGO|conforme banco local|Aplicativo|Código do produto.
ID_VENDA|conforme banco local|Aplicativo|Pedido pai.
ID_PRODUTO|conforme banco local|Aplicativo|Identificador do produto.
UNID|texto|Aplicativo|Unidade.
DESCRICAO|texto|Aplicativo|Descrição.
QUANTIDADE|número|Aplicativo|Quantidade vendida.
PRECO_VENDA|número|Aplicativo|Preço unitário.
STATUS|conforme banco local|Aplicativo|Situação do item.
DESCONTO|número|Aplicativo|Desconto do item.
VST|número|Aplicativo|Valor de substituição tributária.
TOTAL|número|Aplicativo|Total do item.
ID|conforme banco local|Aplicativo|Identificador local do item.
CONFERIDO|conforme banco local|Aplicativo|Indicador de conferência.
ACRESCIMO|número|Aplicativo|Acréscimo do item.
Adicionais|array|Aplicativo|Adicionais e retiradas; A maiúsculo.`) },
  { name: 'Adicionais', path: 'Pedidos[].itens[].Adicionais[]', description: 'Adicionais, retiradas e sabores do item.', fields: parseFields(`
ID|conforme banco local|Aplicativo|Identificador do adicional.
CODIGO|conforme banco local|Aplicativo|Código do adicional ou produto.
VALOR|número|Aplicativo|Valor do adicional.
IDITEM|conforme banco local|Aplicativo|Item de venda pai.
TIPO|conforme banco local|Aplicativo|Tipo do ajuste, como adicional ou retirada.
CODSABOR|conforme banco local|Aplicativo|Código do sabor ou opção.`) },
  { name: 'Pagamento', path: 'Pedidos[].Pagamento[]', description: 'Formas e transações de pagamento. Preenchido no modo PDV; vem vazio nos pedidos da força de vendas.', fields: parseFields(`
ID|conforme banco local|Aplicativo|Identificador do pagamento.
IDFORMA|conforme banco local|Aplicativo|Código da forma de pagamento.
VALOR|número|Aplicativo|Valor pago.
NPV|conforme banco local|Aplicativo|Número do pedido ou venda pai.
DATA|data texto|Aplicativo|Data do pagamento.
PARCELAS|inteiro|Aplicativo|Quantidade de parcelas.
FECHADO|conforme banco local|Aplicativo|Indicador de fechamento.
NSUPIX|texto|Aplicativo|NSU ou identificador PIX.
REDE|texto|Aplicativo|Rede ou adquirente.
NSU|texto|Aplicativo|NSU da transação.
MPBANDEIRA|texto|Aplicativo|Bandeira retornada pelo Mercado Pago.
MPIDPAGTO|texto|Aplicativo|ID do pagamento Mercado Pago.
MPIDEXTORNO|texto|Aplicativo|ID do estorno Mercado Pago.
MPTAXA|número|Aplicativo|Taxa Mercado Pago.
ADQUIRENTE|texto|Aplicativo|Nome ou código da adquirente.
BANDEIRA|texto|Aplicativo|Bandeira normalizada do cartão.
CNPJADQUIRENTE|texto|Aplicativo|CNPJ da adquirente.`) },
  { name: 'ContasRecebidas', path: 'ContasRecebidas[]', description: 'Baixas de títulos realizadas no aplicativo.', fields: parseFields(`
ID|conforme banco local|Aplicativo|Identificador local do recebimento.
IDCRECEBER|conforme banco local|Aplicativo|Título de origem.
DOCUMENTO|texto|Aplicativo|Número do documento.
PEDIDO|conforme banco local|Aplicativo|Pedido relacionado.
DATARECEBIMENTO|data texto|Aplicativo|Data do recebimento.
VALORREC|número|Aplicativo|Valor recebido.
JUROS|número|Aplicativo|Juros recebidos.
DESCONTO|número|Aplicativo|Desconto concedido.
CREDITO|número|Aplicativo|Crédito utilizado ou gerado.
CODCLIENTE|conforme banco local|Aplicativo|Código do cliente.
FORMAPGTO|conforme banco local|Aplicativo|Descrição ou código da forma de pagamento.
OBS|texto|Aplicativo|Observação.
USUREC|conforme banco local|Aplicativo|Usuário que realizou o recebimento.
MOVIMENTO|conforme banco local|Aplicativo|Movimento financeiro relacionado.
TERMINAL|conforme banco local|Aplicativo|Terminal de origem.
IDCARTAO|conforme banco local|Aplicativo|Identificador do cartão ou transação.
VALORDOCUMENTO|número|Aplicativo|Valor original do documento.
IDCREDITO|conforme banco local|Aplicativo|Identificador do crédito relacionado.
HORA|texto|Aplicativo|Hora do recebimento.
IDFORMA|conforme banco local|Aplicativo|Código da forma de pagamento.`) }
];

// Os exemplos abaixo formam uma única carga coerente. As chaves relacionadas
// (cliente, vendedor, grupo, produto, receita e forma de pagamento) coincidem.
const loadExamples = {
  Clientes: [{
    PES_CODI: 1001, FANTASIA: 'MERCADO BOM PREÇO', VDE_CODI: 7,
    NOME_VENDEDOR: 'CARLOS ALMEIDA', PES_NOME: 'MERCADO BOM PREÇO LTDA', IE: '110042490114',
    CMUN: '3550308', PES_ENDE: 'RUA DAS FLORES', PES_NUME: '120', PES_BAIR: 'CENTRO',
    PES_CIDA: 'SAO PAULO', PES_ESTA: 'SP', PES_CEP: '01001000', PES_FONE1: '1130001000',
    PES_FONE2: '', PES_FONE3: '', PES_EMAIL: 'compras@mercadobompreco.com.br',
    PES_NACI: '15/03/2010', PES_CPF: '12345678000190', PES_FJ: 'J', PES_CONTATO: 'ANA SOUZA',
    ALIQIBSMUN: 0.1, IDPAGPREF: '3'
  }],
  Produtos: [{
    COD_PROD: 'PROD-001', UNID: 'UN', DESCRICAO: 'CAFE TORRADO 500G', ANP: '', CEST: '1709600',
    NCM: '09012100', IMPF: 9.25, IMPE: 18, ESTOQUE: 120, ESTOQUE_ATUAL: 118,
    PRECO_VENDA: 18.9, PRECO_VENDA_DESCONTO: 17.9, PRECO_ATACADO: 16.5,
    PRECO_BALCAO: 18.9, PRECO_BALCAO_DESCONTO: 17.9, COMISSAO: 2,
    DESCMAX: 10, VALOR_COMISSAO: 0.38, MARCA: 'SERRA ALTA', MODELO: '', DESCONTO: 0,
    CFOP: '5102', CST: '102', ALIQUOTA: 18, CSTPIS: '49', PIS: 0.65, COFINS: 3,
    IPI: 0, ID: 2001, GTIN: '7891234567895', MEDIO: 12.75, STATUS: 'ATIVO',
    REMICMSRETEN: 0, GRUPO: 10, IDRECEITA: 900, CBENEF: '', ALIQNAC: 9.25,
    ESTADUAL: 18, imagem: '', CCLASSTRIB: '000001', ALIQIBS: 0.1,
    PERC_REDUCAO_IBS: 0, PERC_REDUCAO_CBS: 0, NSABORES: 0
  }],
  Mva: [{ ID: 301, UF: 'SP', ALIQUOTA: 40, IDPRODUTO: 2001, FCP: 2, FCPST: 2 }],
  ContasReceber: [{
    ID: 7001, DOCUMENTO: 'DUP-2026-001', PES_CODI: 1001, PREC_DTVCTO: '15/09/2026',
    PREC_DTEMIS: '31/08/2026', PREC_VLRPAR: 350.75, PREC_MORADIA: 0.33,
    PREC_MULTA: 7.02, BCO_CODI: 1, BCO_NOME: 'CAIXA GERAL'
  }],
  FormaPgto: [{
    CPGTO_CODI: 3, CPGTO_DESC: 'PIX', CPGTO_COND: 'A VISTA', DIAS: '0', PARCELA: 1,
    CPGTO_DESCO: 0, CRECEBER: 'NAO', TPCARTAO: '', CNPJ: ''
  }],
  Empresa: [{
    CODIGO: 1, RAZAO: 'DISTRIBUIDORA EXEMPLO LTDA', REGIME: 1, UF: 'SP',
    CPFCNPJ: '98765432000110', FANTASIA: 'DISTRIBUIDORA EXEMPLO', ENDERECO: 'AVENIDA CENTRAL',
    NUMERO: '500', BAIRRO: 'INDUSTRIAL', CMUN: '3550308', CIDADE: 'SAO PAULO',
    CEP: '01153000', FONE: '1133334444', IE: '110944020115', CONSUMACAO: 0,
    COUVERART: 0, ALIQCBS: 0.9
  }],
  Vendedores: [{ ID: 7, NOME: 'CARLOS ALMEIDA', SENHA: '1234' }],
  Anp: [{
    ID: 501, CODIGO: '210203001', DESCRICAO: 'GLP', GLP: 100, GNN: 0,
    GNI: 0, CODIF: 'CODIF-EXEMPLO', QTEMP: 20
  }],
  AliqUF: [{
    ID: 35, CODIGOESTADO: 35, ESTADO: 'SP', NOME: 'SAO PAULO', ALIQUOTAICMS: 18,
    IVA: 40, ICMSI: 12, FCP: 2
  }],
  Grupos: [{
    ID: 10, CODGRUPO: 10, DESCRICAO: 'MERCEARIA', MARKUP: 35, ENVIA: 'SIM',
    CODUAIRANGO: '', CODWOO: '', CODCONSIDERAR: '10'
  }],
  Composicao: [{
    ID: 901, IDRECEITA: 900, CODIGO: 'PROD-001', QTDE: 1,
    OBS: 'ITEM PRINCIPAL DA COMPOSICAO', ACRESCIMO: 0
  }],
  ItensAcrescimo: [{
    ID: 801, CODIGO: 'ADC-001', ACRESCIMO: 2.5, CODPRODUTO: 'PROD-001',
    IDCATEGORIA: 10, QTDE: 1, MEIAPIZZA: 'NAO'
  }],
  Opcoesdoitem: [{
    ID: 601, DESCRICAO: 'EMBALAGEM PARA PRESENTE', CODPRODUTO: 'PROD-001',
    VALOR: 3, MPIZZA: 'NAO', CODOPCAO: ''
  }],
  PrecoDiferenciado: [{ ID: 4001, CODIGO: '7891234567895', VALOR: 17.5, IDCLI: 1001 }]
};

const completeLoadJson = JSON.stringify(loadExamples, null, 2);
const completeLoadResponse = JSON.stringify({
  success: true,
  arquivo: {
    nome: 'Dados.json',
    dados: loadExamples,
    data_atualizacao: '2026-08-31T17:30:00.000Z'
  }
}, null, 2);

const loadRoot = `{
  "Clientes": [],
  "Produtos": [],
  "Mva": [],
  "ContasReceber": [],
  "FormaPgto": [],
  "Empresa": [],
  "Vendedores": [],
  "Anp": [],
  "AliqUF": [],
  "Grupos": [],
  "Composicao": [],
  "ItensAcrescimo": [],
  "Opcoesdoitem": [],
  "PrecoDiferenciado": []
}`;

const appExample = {
  Pedidos: [{
    CODIGO: 501, ID_CLIENTE: 1001, ID_MOBILE_CLI: 1001, PES_NOME: 'MERCADO BOM PREÇO LTDA',
    ID_CPGTO_CODI: 3, DATA_VENDA: '31/08/2026 14:30:00',
    OBS: 'ENTREGAR NO PERIODO DA TARDE', STATUS_TRANSM: 'PENDENTE', DATA_TRANSMITIDO: '',
    ITENS_OK: 'SIM', CHAVE: '', CHAVENFCE: '', NFCE: 0, PROTOCOLONFCE: '',
    PROTOCOLONFE: '', RECIBONFCE: '', RECIBONFE: '', NFCECSTAT: 0, NFECSTAT: 0,
    DFE_DOCUMENTO_ID: 0, DFE_STATUS: '', DFE_XML_PATH: '', DFE_PDF_PATH: '',
    DFE_DATA_AUTORIZACAO: '', CONTINGENCIA: 'NAO', CODVENDEDOR: 7,
    VENDEDOR: 'CARLOS ALMEIDA', SERIE: 1, SERIENFE: 1, NFE: 0, ASSINATURA_B64: '',
    itens: [{
      CODIGO: 'PROD-001', ID_VENDA: 501, ID_PRODUTO: 2001, UNID: 'UN',
      DESCRICAO: 'CAFE TORRADO 500G', QUANTIDADE: 2, PRECO_VENDA: 18.9,
      STATUS: 'ATIVO', DESCONTO: 0, VST: 0, TOTAL: 40.8, ID: 1,
      CONFERIDO: 'SIM', ACRESCIMO: 3,
      Adicionais: [{ ID: 1, CODIGO: 'ADC-001', VALOR: 3, IDITEM: 1, TIPO: 'ADICIONAL', CODSABOR: 0 }]
    }],
    Pagamento: [{
      ID: 1, IDFORMA: 3, VALOR: 40.8, NPV: 501, DATA: '31/08/2026', PARCELAS: 1,
      FECHADO: 'SIM', NSUPIX: 'E123456782026083114300001', REDE: 'PIX', NSU: '',
      MPBANDEIRA: '', MPIDPAGTO: '', MPIDEXTORNO: '', MPTAXA: 0,
      ADQUIRENTE: 'BANCO EXEMPLO', BANDEIRA: '', CNPJADQUIRENTE: '00000000000191'
    }]
  }],
  ContasRecebidas: [{
    ID: 1, IDCRECEBER: 7001, DOCUMENTO: 'DUP-2026-001', PEDIDO: 501,
    DATARECEBIMENTO: '31/08/2026', VALORREC: 350.75, JUROS: 0, DESCONTO: 0,
    CREDITO: 0, CODCLIENTE: 1001, FORMAPGTO: 'PIX', OBS: 'RECEBIMENTO INTEGRAL',
    USUREC: 'CARLOS ALMEIDA', MOVIMENTO: 9001, TERMINAL: 'SMARTPOS-01', IDCARTAO: 0,
    VALORDOCUMENTO: 350.75, IDCREDITO: 0, HORA: '14:35:00', IDFORMA: 3
  }]
};

const appExamples = {
  Pedidos: appExample.Pedidos,
  Itens: appExample.Pedidos[0].itens,
  Adicionais: appExample.Pedidos[0].itens[0].Adicionais,
  Pagamento: appExample.Pedidos[0].Pagamento,
  ContasRecebidas: appExample.ContasRecebidas
};

const appJson = JSON.stringify(appExample, null, 2);

const CodeBlock = ({ children, onCopy, label = 'JSON' }) => (
  <div className="integration-code-block">
    <div><span>{label}</span><button type="button" onClick={() => onCopy(children)}>Copiar</button></div>
    <pre>{children}</pre>
  </div>
);

const FieldTable = ({ fields }) => (
  <div className="integration-table-wrap">
    <table className="integration-fields-table">
      <thead><tr><th>Campo</th><th>Tipo</th><th>Obrigatório / origem</th><th>Finalidade e regra</th></tr></thead>
      <tbody>{fields.map((field) => <tr key={field.name}>
        <td><code>{field.name}</code></td><td>{field.type}</td>
        <td><span className={`field-required ${field.required === 'Sim' ? 'yes' : ''}`}>{field.required}</span></td>
        <td>{field.description}</td>
      </tr>)}</tbody>
    </table>
  </div>
);

const CredenciaisMaiusculas = () => (
  <section className="doc-notes warning">
    <h3>Usuário e senha sempre em LETRAS MAIÚSCULAS</h3>
    <p>Envie <code>Vendedores.NOME</code> (usuário) e <code>Vendedores.SENHA</code> (senha) em <strong>letras maiúsculas</strong>. Por boas práticas, o aplicativo trata usuário e senha sempre em maiúsculas, para que o vendedor não precise lembrar de uma senha sensível a maiúsculas e minúsculas. No login, o que é digitado é convertido para maiúsculas e comparado com a carga. Por isso, um cadastro como <code>joao</code> / <code>abc123</code> nunca será aceito: envie <code>JOAO</code> / <code>ABC123</code>.</p>
  </section>
);

const PagamentoPorModo = () => (
  <section className="doc-notes warning">
    <h3>Onde vem o pagamento: força de vendas × PDV</h3>
    <p>O JSON tem a mesma estrutura nos dois modos, mas o pagamento vem em lugares diferentes. Trate os dois casos na importação do <code>GET /app/pedidos/download</code>:</p>
    <div className="integration-table-wrap">
      <table className="integration-fields-table">
        <thead><tr><th>Informação</th><th>Força de vendas</th><th>PDV</th></tr></thead>
        <tbody>
          <tr><td><code>Pedidos[].ID_CPGTO_CODI</code></td><td>Forma de pagamento do pedido. <strong>É a única informação de pagamento.</strong></td><td>Apenas uma das formas usadas. Em venda com mais de uma forma, não representa o pagamento completo.</td></tr>
          <tr><td><code>Pedidos[].Pagamento[]</code></td><td><strong>Sempre vazio</strong> (<code>[]</code>).</td><td><strong>Fonte oficial do pagamento:</strong> um registro por forma usada, com <code>IDFORMA</code> e <code>VALOR</code>.</td></tr>
          <tr><td>Valor pago</td><td>Não é enviado. Considere o total do pedido, calculado a partir dos itens.</td><td><code>Pagamento[].VALOR</code>.</td></tr>
          <tr><td>Parcelas e dados da transação</td><td>Não são enviados.</td><td><code>PARCELAS</code>, <code>NSU</code>, <code>BANDEIRA</code>, <code>ADQUIRENTE</code> e <code>CNPJADQUIRENTE</code>. Os valores dependem da forma usada.</td></tr>
        </tbody>
      </table>
    </div>
    <p><strong>Regra de importação:</strong> se <code>Pagamento</code> tiver registros, use esse array e ignore <code>ID_CPGTO_CODI</code>. Se estiver vazio, registre um pagamento único com a forma de <code>ID_CPGTO_CODI</code> e o total do pedido. Se <code>ID_CPGTO_CODI</code> também for <code>0</code>, o aplicativo não informou a forma de pagamento.</p>
  </section>
);

const DatasetDictionary = ({ datasets, search, setSearch, examples, onCopy }) => {
  const normalized = search.trim().toLocaleLowerCase('pt-BR');
  const filtered = useMemo(() => datasets.map((dataset) => ({
    ...dataset,
    fields: normalized ? dataset.fields.filter((field) => `${dataset.name} ${dataset.description} ${field.name} ${field.type} ${field.description}`.toLocaleLowerCase('pt-BR').includes(normalized)) : dataset.fields
  })).filter((dataset) => dataset.fields.length), [datasets, normalized]);
  return <>
    <div className="integration-search"><span>⌕</span><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Buscar conjunto, campo ou finalidade..." /><small>{filtered.reduce((total, item) => total + item.fields.length, 0)} campos</small></div>
    <div className="dataset-list">
      {filtered.map((dataset, index) => <details className="dataset-card" key={dataset.name} open={Boolean(normalized) || index === 0}>
        <summary><div><code>{dataset.name}</code><span>{dataset.path || `Tabela local: ${dataset.table}`}</span></div><p>{dataset.description}</p><b>{dataset.fields.length} campos</b></summary>
        {dataset.name === 'Vendedores' && <CredenciaisMaiusculas/>}
        <FieldTable fields={dataset.fields}/>
        {examples?.[dataset.name] && <div className="dataset-example"><CodeBlock onCopy={onCopy} label={`EXEMPLO · ${dataset.name}[]`}>{JSON.stringify(examples[dataset.name][0], null, 2)}</CodeBlock></div>}
      </details>)}
      {!filtered.length && <div className="integration-empty">Nenhum campo encontrado para “{search}”.</div>}
    </div>
  </>;
};

const datasetRelationNotes = {
  Clientes: 'PES_CODI identifica o cliente. IDPAGPREF aponta para FormaPgto.CPGTO_CODI e VDE_CODI identifica o vendedor.',
  Produtos: 'ID é o identificador interno; GTIN é a chave funcional usada por composição, adicionais, opções e preços diferenciados. GRUPO aponta para Grupos.CODGRUPO.',
  Grupos: 'CODGRUPO é referenciado por Produtos.GRUPO. Ingredientes e adicionais não precisam de um grupo próprio.',
  Composicao: 'IDRECEITA deve coincidir com Produtos.IDRECEITA do produto pai. CODIGO aponta para Produtos.GTIN do ingrediente ou componente.',
  ItensAcrescimo: 'CODPRODUTO aponta para o GTIN do produto pai; CODIGO aponta para o GTIN do adicional. IDCATEGORIA apenas organiza a interface.',
  Opcoesdoitem: 'CODPRODUTO aponta para o GTIN do produto pai. Em pizza, CODOPCAO aponta para o GTIN do produto-sabor e MPIZZA deve ser SIM.',
  Mva: 'IDPRODUTO aponta para Produtos.ID. A UF define onde a regra fiscal será aplicada.',
  FormaPgto: 'CPGTO_CODI é usado por Clientes.IDPAGPREF e retorna nos pedidos como ID_CPGTO_CODI ou Pagamento.IDFORMA.',
  Empresa: 'CODIGO identifica a empresa/filial responsável pela carga e seus dados fiscais.',
  ContasReceber: 'PES_CODI liga o título a Clientes.PES_CODI.',
  Vendedores: 'ID é relacionado ao código de vendedor enviado em clientes e pedidos.',
  Anp: 'Cadastro fiscal auxiliar usado por produtos sujeitos à ANP.',
  AliqUF: 'ESTADO/UF seleciona a tributação interestadual aplicável.',
  PrecoDiferenciado: 'IDCLI aponta para Clientes.PES_CODI e CODIGO aponta para Produtos.GTIN.'
};

const FullJsonGuide = ({ onCopy }) => {
  const [fullJson, setFullJson] = useState('');
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState('Produtos');

  useEffect(() => {
    let active = true;
    const findLoadRequest = (items = []) => {
      for (const item of items) {
        if (item.request?.method === 'POST' && item.request?.url?.raw?.includes('/carga-dados')) return item.request;
        const child = findLoadRequest(item.item);
        if (child) return child;
      }
      return null;
    };

    fetch('/downloads/DTVenda-Carga-Pedidos.postman_collection.json')
      .then((response) => {
        if (!response.ok) throw new Error(`Não foi possível carregar a collection (HTTP ${response.status}).`);
        return response.json();
      })
      .then((collection) => {
        const request = findLoadRequest(collection.item);
        if (!request?.body?.raw) throw new Error('A requisição completa de carga não foi encontrada na collection.');
        const parsed = JSON.parse(request.body.raw);
        if (active) {
          setFullJson(JSON.stringify(parsed, null, 2));
          setPayload(parsed?.dados?.dados || parsed?.dados || {});
        }
      })
      .catch((loadError) => { if (active) setError(loadError.message); });
    return () => { active = false; };
  }, []);

  const dataset = loadDatasets.find((item) => item.name === selected) || loadDatasets[0];
  const records = Array.isArray(payload?.[selected]) ? payload[selected] : [];
  const readableRecords = records.slice(0, 2).map((record) => {
    if (!record || typeof record !== 'object' || !record.imagem) return record;
    return { ...record, imagem: `${record.imagem.slice(0, 80)}... [Base64 completo com ${record.imagem.length} caracteres no JSON abaixo]` };
  });

  return <div className="full-json-guide">
    <section className="integration-section-card json-complete-hero"><span className="eyebrow">MODELO OFICIAL DA COLLECTION</span><h3>JSON completo, válido e pronto para copiar</h3><p>Este conteúdo é carregado diretamente da collection publicada no portal e possui pelo menos dois registros em cada uma das 14 tags, incluindo os exemplos completos de bebidas, pizza, açaí, adicionais e retiradas. As imagens Base64 permanecem completas. Como JSON não aceita comentários, as explicações aparecem nos painéis abaixo sem invalidar o arquivo.</p>
      <div className="json-complete-stats"><span><strong>14</strong> tags obrigatórias</span><span><strong>2+</strong> registros por tag</span><span><strong>UTF-8</strong> sem comentários internos</span><span><strong>Base64</strong> completo</span></div>
      {error && <div className="integration-empty">{error}</div>}
      {!error && !fullJson && <div className="integration-empty">Carregando o JSON completo da collection...</div>}
      {fullJson && <details className="full-json-source" open><summary><span>Visualizar o envelope completo enviado para <code>POST /carga-dados</code></span><b>{fullJson.length.toLocaleString('pt-BR')} caracteres</b></summary><CodeBlock onCopy={onCopy} label="JSON COMPLETO · PELO MENOS 2 REGISTROS POR TAG">{fullJson}</CodeBlock></details>}
    </section>

    <section className="integration-section-card"><span className="eyebrow">JSON COMENTADO</span><h3>Selecione uma tag para entender campo por campo</h3><p>O painel combina a finalidade da tag, sua amarração, a tabela de campos e os dois registros usados no JSON completo.</p>
      <div className="json-tag-selector">{loadDatasets.map((item) => <button type="button" className={selected === item.name ? 'active' : ''} onClick={() => setSelected(item.name)} key={item.name}>{item.name}<small>{Array.isArray(payload?.[item.name]) ? payload[item.name].length : '—'} registros</small></button>)}</div>
      <div className="json-tag-header"><div><span>TAG SELECIONADA</span><h4>{dataset.name}</h4><p>{dataset.description}</p></div><aside><b>Amarração principal</b><p>{datasetRelationNotes[dataset.name]}</p></aside></div>
      {selected === 'Vendedores' && <CredenciaisMaiusculas/>}
      <FieldTable fields={dataset.fields}/>
      <CodeBlock onCopy={onCopy} label={`EXEMPLOS COMENTADOS · dados.${dataset.name}`}>{JSON.stringify(readableRecords, null, 2)}</CodeBlock>
      {selected === 'Produtos' && <div className="envelope-note"><strong>Sobre <code>imagem</code></strong><span>A prévia acima encurta o Base64 para facilitar a leitura. No JSON completo, a imagem permanece integral e pronta para ser importada pelo aplicativo.</span></div>}
    </section>
  </div>;
};

const componentSetupCode = `uses
  DTVenda.Component, DTVenda.Types, DTVenda.Responses;

// O componente visual fica na paleta "DT Inovacao".
// Arraste TDTVenda para o formulario e configure:
DTVenda1.Configuracoes.BaseURL := 'https://apidtvenda.dtinovacao.com.br';
DTVenda1.Configuracoes.Token := TokenDoAplicativo;
DTVenda1.Configuracoes.NomeArquivo := 'dados.json';
DTVenda1.Configuracoes.ConnectionTimeout := 15000;
DTVenda1.Configuracoes.ResponseTimeout := 60000;`;

const componentLoadCode = `var
  Produto: TDTVendaProduto;
  Resposta: TDTVendaHttpResult;
begin
  DTVenda1.LimparCarga;

  Produto := DTVenda1.Produtos.Add;
  Produto.COD_PROD := 'BEB-001';
  Produto.DESCRICAO := 'REFRIGERANTE COLA 350ML';
  Produto.UNID := 'UN';
  Produto.PRECO_VENDA := 6.50;
  Produto.imagem := TDTVenda.ArquivoParaBase64('C:\\Imagens\\bebida.jpg');

  // Repita o mesmo padrão em Clientes, Grupos, FormaPgto e
  // nas demais coleções. GerarEnvelopeJSON permite conferir antes.
  MemoJSON.Text := DTVenda1.GerarEnvelopeJSON(True);

  Resposta := DTVenda1.EnviarCarga;
  try
    MemoResposta.Text := Resposta.Body;
  finally
    Resposta.Free;
  end;
end;`;

const componentMasterDataCode = `// Cliente
with DTVenda1.Clientes.Add do
begin
  PES_CODI := 1001;
  PES_NOME := 'MERCADO BOM PRECO LTDA';
  FANTASIA := 'MERCADO BOM PRECO';
  PES_CPF := '12345678000190';
  VDE_CODI := '7';
  IDPAGPREF := 3;
end;

// Grupo usado por Produtos.GRUPO
with DTVenda1.Grupos.Add do
begin
  ID := 20;
  CODGRUPO := 20;
  DESCRICAO := 'BEBIDAS';
end;

// Forma usada por Clientes.IDPAGPREF e pelos pedidos
with DTVenda1.FormaPgto.Add do
begin
  CPGTO_CODI := 3;
  CPGTO_DESC := 'PIX';
  CPGTO_COND := 'V';
  PARCELA := 1;
  CRECEBER := 'NAO';
end;`;

const componentOrdersCode = `var
  Pendentes: TDTVendaPedidosPendentes;
  Pendente: TDTVendaPedidoPendente;
  Pedido: TDTVendaPedidoDetalhe;
  Item: TDTVendaPedidoItem;
  Adicional: TDTVendaPedidoAdicional;
  Pagamento: TDTVendaPedidoPagamento;
begin
  Pendentes := DTVenda1.ListarPedidosPendentes;
  try
    for Pendente in Pendentes do
    begin
      DTVenda1.CarregarDetalhePedidoPorID(Pendente.ID);

      for Pedido in DTVenda1.DetalhePedidos do
      begin
        for Item in Pedido.Itens do
          for Adicional in Item.Adicionais do
            ProcessarAdicional(Pedido, Item, Adicional);

        for Pagamento in Pedido.Pagamentos do
          ProcessarPagamento(Pagamento.IDForma,
            Pagamento.Descricao, Pagamento.Valor,
            Pagamento.GeradoDoCabecalho);
      end;

      // Confirme somente depois do COMMIT da transação no ERP.
      ConfirmarDepoisDoCommit(Pendente.ID);
    end;
  finally
    Pendentes.Free;
  end;
end;`;

const dllCode = `uses
  System.IOUtils, DTVenda.API.Client;

var
  API: TDTVendaAPIClient;
  JSON: string;
begin
  API := TDTVendaAPIClient.Create(
    TPath.Combine(ExtractFilePath(ParamStr(0)), 'DTVendaAPI.dll'));
  try
    API.Configurar(BaseURL, TokenDoAplicativo, 'dados.json');
    API.DefinirCargaJSON(JSONDaCarga);
    JSON := API.EnviarCarga;
    JSON := API.ListarPedidosPendentes;
    JSON := API.BaixarPedidoPorID(123);
    JSON := API.ConfirmarPedido(123);
  finally
    API.Free;
  end;
end;`;

const relationshipScenarios = [
  {
    id: 'retirada', label: 'Retirada', title: 'Ingredientes que podem ser retirados',
    summary: 'A retirada nasce na composição da receita. O produto pai informa a receita e cada composição aponta para o GTIN de um ingrediente cadastrado em Produtos.',
    links: ['Produtos.IDRECEITA = Composicao.IDRECEITA', 'Composicao.CODIGO = Ingrediente.GTIN', 'Composicao.OBS descreve a retirada'],
    code: `// Produto pai
with DTVenda1.Produtos.Add do
begin
  COD_PROD := 'LAN-001';
  GTIN := '7890000001001';
  IDRECEITA := 900;
end;

// Ingrediente também existe em Produtos
with DTVenda1.Produtos.Add do
begin
  COD_PROD := 'ING-001';
  GTIN := '7890000004001';
  DESCRICAO := 'CEBOLA';
end;

// A receita 900 pertence ao LAN-001 e aponta para a cebola
with DTVenda1.Composicao.Add do
begin
  IDRECEITA := 900;
  CODIGO := '7890000004001';
  QTDE := 1;
  OBS := 'PODE RETIRAR A CEBOLA';
end;`
  },
  {
    id: 'adicionais', label: 'Adicionais', title: 'Adicionais vinculados ao produto pai',
    summary: 'O produto adicional também deve existir em Produtos. ItensAcrescimo liga o GTIN do pai ao GTIN do adicional e define preço, quantidade e categoria visual.',
    links: ['ItensAcrescimo.CODPRODUTO = ProdutoPai.GTIN', 'ItensAcrescimo.CODIGO = ProdutoAdicional.GTIN', 'IDCATEGORIA apenas organiza a tela'],
    code: `// LAN-001 (pai) oferece ADC-001 (bacon)
with DTVenda1.ItensAcrescimo.Add do
begin
  ID := 801;
  CODPRODUTO := '7890000001001'; // GTIN do lanche
  CODIGO := '7890000003001';    // GTIN do bacon
  ACRESCIMO := 4;
  IDCATEGORIA := 1;
  QTDE := 1;
  MEIAPIZZA := '';
end;`
  },
  {
    id: 'pizza', label: 'Pizza', title: 'Pizza, sabores e adicionais por metade',
    summary: 'A pizza informa quantos sabores aceita. Cada opção aponta para o GTIN da pizza e para o GTIN do produto-sabor. Adicionais com MEIAPIZZA=SIM podem ser aplicados somente em uma metade.',
    links: ['Pizza.NSABORES = 2', 'Opcao.CODPRODUTO = Pizza.GTIN', 'Opcao.CODOPCAO = ProdutoSabor.GTIN', 'MPIZZA = SIM', 'MEIAPIZZA = SIM'],
    code: `with DTVenda1.Produtos.Add do
begin
  COD_PROD := 'PIZ-001';
  GTIN := '7890000005001';
  NSABORES := 2;
  IDRECEITA := 910;
end;

with DTVenda1.Opcoesdoitem.Add do
begin
  DESCRICAO := 'PIZZA CALABRESA';
  CODPRODUTO := '7890000005001'; // pizza pai
  CODOPCAO := '7890000005101';  // produto-sabor
  VALOR := 30;
  MPIZZA := 'SIM';
end;

with DTVenda1.ItensAcrescimo.Add do
begin
  CODPRODUTO := '7890000005001'; // pizza pai
  CODIGO := '7890000005201';    // catupiry
  ACRESCIMO := 4;
  MEIAPIZZA := 'SIM';
end;`
  },
  {
    id: 'acai', label: 'Açaí', title: 'Açaí com tamanho e complementos',
    summary: 'O tamanho é uma opção normal, sem produto-sabor. Os complementos são adicionais ligados ao GTIN do açaí e aplicados ao item inteiro.',
    links: ['Acai.NSABORES = 1', 'Opcao.CODPRODUTO = Acai.GTIN', 'CODOPCAO vazio', 'MPIZZA = NAO', 'MEIAPIZZA = NAO'],
    code: `with DTVenda1.Produtos.Add do
begin
  COD_PROD := 'ACA-001';
  GTIN := '7890000006001';
  NSABORES := 1;
end;

with DTVenda1.Opcoesdoitem.Add do
begin
  DESCRICAO := 'COPO GRANDE';
  CODPRODUTO := '7890000006001';
  CODOPCAO := '';
  VALOR := 20;
  MPIZZA := 'NAO';
end;

with DTVenda1.ItensAcrescimo.Add do
begin
  CODPRODUTO := '7890000006001';
  CODIGO := '7890000006102'; // Nutella cadastrada em Produtos
  ACRESCIMO := 3;
  MEIAPIZZA := 'NAO';
end;`
  }
];

const directOrdersCode = `// 1. Listar pendentes
GET /api/app/pedidos-pendentes
X-API-Token: TOKEN_DO_APLICATIVO

// 2. Baixar o conteúdo pelo ID retornado
GET /api/app/pedidos/download?id=123
X-API-Token: TOKEN_DO_APLICATIVO

// 3. Gravar pedido, itens, adicionais e pagamentos no ERP
// Faça toda a gravação dentro de uma transação.

// 4. Somente depois do COMMIT, confirmar a sincronização
PUT /api/app/pedidos/sincronizar
X-API-Token: TOKEN_DO_APLICATIVO
Content-Type: application/json

{ "id": 123 }`;

const componentApiCode = `// Enviar a carga montada nas coleções tipadas
Resposta := DTVenda1.EnviarCarga;

// Receber e percorrer os pedidos sem interpretar JSON manualmente
Pendentes := DTVenda1.ListarPedidosPendentes;
for Pendente in Pendentes do
begin
  DTVenda1.CarregarDetalhePedidoPorID(Pendente.ID);
  for Pedido in DTVenda1.DetalhePedidos do
    ImportarPedidoTipado(Pedido);

  // Chamar somente após o COMMIT no ERP
  Resposta := DTVenda1.ConfirmarPedido(Pendente.ID);
end;`;

export default function IntegrationDocs({ base, info, onCopy, showAdministrativeToken = false }) {
  const [tab, setTab] = useState('inicio');
  const [loadSearch, setLoadSearch] = useState('');
  const [appSearch, setAppSearch] = useState('');
  const [jsonView, setJsonView] = useState('completo');
  const [scenario, setScenario] = useState('retirada');
  const [apiView, setApiView] = useState('direta');
  const tabs = [
    ['inicio', 'Comece aqui'], ['componente', '1. Componente e DLL'], ['json', '2. JSON e amarrações'], ['api', '3. API e pedidos']
  ];
  const selectedScenario = relationshipScenarios.find((item) => item.id === scenario) || relationshipScenarios[0];

  const postLoad = `POST ${base}/carga-dados\nX-API-Token: TOKEN_DO_APP\nContent-Type: application/json\n\n${JSON.stringify({ nome_arquivo: 'Dados.json', dados: JSON.parse(loadRoot) }, null, 2)}`;
  const postCompleteLoad = `POST ${base}/carga-dados\nX-API-Token: TOKEN_DO_APP\nContent-Type: application/json\n\n${JSON.stringify({ nome_arquivo: 'Dados.json', dados: JSON.parse(completeLoadJson) }, null, 2)}`;
  const postOrders = `POST ${base}/pedidos\nX-API-Token: TOKEN_DO_APP\nContent-Type: application/json\n\n${JSON.stringify({ nome_arquivo: 'pedidos_20260831_143000.json', pedidos: JSON.parse(appJson) }, null, 2)}`;

  return <div className="integration-manual">
    {showAdministrativeToken && info?.integration_token && <section className="integration-token"><div><span>Token administrativo da Software House</span><strong>{info.integration_token}</strong></div><button onClick={() => onCopy(info.integration_token)}>Copiar token</button></section>}
    <div className="integration-alert"><strong>Autenticação por aplicativo:</strong> todas as rotas desta integração usam o token individual de 8 caracteres no cabeçalho <code>X-API-Token</code>. O token administrativo acima identifica a Software House e não substitui o token instalado no aplicativo.</div>
    <nav className="integration-doc-tabs" aria-label="Seções da documentação">
      {tabs.map(([id, label]) => <button type="button" className={tab === id ? 'active' : ''} onClick={() => setTab(id)} key={id}>{label}</button>)}
    </nav>

    {tab === 'inicio' && <div className="integration-tab-panel">
      <section className="integration-intro-card"><span className="eyebrow">CONTRATO DE SINCRONIZAÇÃO</span><h3>Dois JSONs, duas direções</h3><p>O ERP publica uma carga completa para abastecer o aplicativo. Depois, o aplicativo devolve pedidos e contas recebidas para importação no ERP.</p>
        <div className="integration-flow"><article><b>1</b><span><small>ERP → API → APLICATIVO</small><strong>Publicar <code>Dados.json</code></strong><p>Clientes, produtos, preços, estoque, tributação e cadastros auxiliares.</p></span></article><i>→</i><article><b>2</b><span><small>APLICATIVO → API → ERP</small><strong>Receber pedidos</strong><p>Pedidos, itens, adicionais, pagamentos e contas recebidas.</p></span></article></div>
      </section>
      <div className="integration-rule-grid">
        <article><b>UTF-8</b><p>Use codificação UTF-8 e respeite exatamente maiúsculas e minúsculas.</p></article>
        <article><b>Carga completa</b><p>Não é incremental. Cada conjunto substitui integralmente a tabela local correspondente.</p></article>
        <article><b>14 arrays</b><p>Envie todos, inclusive sem registros. Nesse caso, use <code>[]</code>.</p></article>
        <article><b>Tipos JSON</b><p>Números sem aspas e com ponto decimal. Textos vazios como <code>""</code>, nunca <code>null</code>.</p></article>
        <article><b>Datas</b><p>Na carga, use texto em <code>DD/MM/AAAA</code>, por exemplo <code>31/08/2026</code>.</p></article>
        <article><b>Validação</b><p>Valide tudo antes de publicar: um erro pode interromper a importação após apagar uma tabela.</p></article>
      </div>
      <section className="integration-resource-card">
        <div><span className="eyebrow">KIT DE INTEGRAÇÃO</span><h3>Escolha como deseja integrar</h3><p>Use o componente visual ou a DLL em projetos Delphi. Para integração HTTP, baixe a collection com carga, listagem, download e confirmação de pedidos.</p></div>
        <div className="integration-resource-actions"><button className="resource-button primary" type="button" onClick={() => setTab('componente')}>Ver componente e DLL</button><a className="resource-button" href="/downloads/DTVenda-Carga-Pedidos.postman_collection.json" download>Baixar collection Postman</a><button className="resource-button" type="button" onClick={() => onCopy(base)}>Copiar URL base</button></div>
      </section>
      <section className="doc-notes warning"><h3>Atenção: substituição integral</h3><p>Antes de importar cada conjunto, o aplicativo apaga os registros locais daquela tabela. Campos ausentes, nomes incorretos ou tipos inválidos podem deixar dados incompletos. Garanta também as referências entre clientes, vendedores, grupos, produtos, formas de pagamento e receitas.</p></section>
      <CredenciaisMaiusculas/>
    </div>}

    {tab === 'componente' && <div className="integration-tab-panel">
      <section className="integration-section-card"><span className="eyebrow">DELPHI · INTEGRAÇÃO TIPADA</span><h3>Escolha a forma de consumo</h3><p>As três opções usam o mesmo token individual do aplicativo e o mesmo contrato JSON. O componente é a opção mais produtiva em Delphi; a DLL atende projetos que preferem uma interface binária; Postman e HTTP são ideais para homologação ou outras linguagens.</p>
        <div className="integration-choice-grid"><article><span>RECOMENDADO PARA DELPHI</span><h4>Componente visual</h4><p>Arraste <code>TDTVenda</code> da paleta <strong>DT Inovacao</strong>, alimente coleções tipadas e trabalhe com pedidos também tipados.</p></article><article><span>DLL WIN32</span><h4>DTVendaAPI.dll</h4><p>Interface Unicode <code>stdcall</code>, utilizável por Delphi, C/C++, C#, Python e outras linguagens para Windows.</p></article><article><span>QUALQUER PLATAFORMA</span><h4>HTTP / Postman</h4><p>Use os endpoints REST diretamente e importe a collection pronta disponibilizada nesta página.</p></article></div>
      </section>

      <section className="integration-section-card"><h3>1. Instalar e configurar o componente</h3><p>Abra <code>Packages/DTVenda.dproj</code> no Delphi, compile e instale o package Win32. Depois adicione o caminho da pasta <code>Source</code> ao Library Path. O token deve ser o token de 8 caracteres do aplicativo, nunca o token administrativo da Software House.</p><CodeBlock onCopy={onCopy} label="CONFIGURAÇÃO DO TDTVENDA">{componentSetupCode}</CodeBlock></section>

      <section className="integration-section-card"><h3>2. Montar e enviar a carga de forma tipada</h3><p>Cada tag do JSON possui uma coleção correspondente: <code>Clientes</code>, <code>Produtos</code>, <code>Grupos</code>, <code>Composicao</code>, <code>ItensAcrescimo</code>, <code>Opcoesdoitem</code>, <code>Mva</code>, <code>FormaPgto</code>, <code>Empresa</code>, <code>ContasReceber</code>, <code>Vendedores</code>, <code>Anp</code>, <code>AliqUF</code> e <code>PrecoDiferenciado</code>. Os trechos abaixo destacam as propriedades principais; consulte <strong>JSON e amarrações → Campos da carga</strong> para preencher todos os campos do contrato.</p><div className="api-guide-grid"><article><span>CADASTROS RELACIONADOS</span><h4>Cliente, grupo e pagamento</h4><p>Cadastre primeiro os registros referenciados por outros conjuntos.</p><CodeBlock onCopy={onCopy} label="DELPHI · TRECHO DOS CADASTROS">{componentMasterDataCode}</CodeBlock></article><article><span>PRODUTO E ENVIO</span><h4>Imagem, JSON e requisição</h4><p>A imagem é convertida para Base64 pelo próprio componente.</p><CodeBlock onCopy={onCopy} label="DELPHI · PRODUTO E ENVIO">{componentLoadCode}</CodeBlock></article></div><div className="envelope-note"><strong>Propriedade singular</strong><span><code>DTVenda1.Produto.Add</code> é um atalho para <code>DTVenda1.Produtos.Add</code>. A forma plural deixa mais claro que se trata de uma coleção.</span></div></section>

      <section className="integration-section-card"><span className="eyebrow">EXEMPLOS DO PROJETO DEMO</span><h3>Preenchimentos completos por cenário</h3><p>Selecione um cenário para visualizar o código tipado e as chaves usadas. Os mesmos exemplos estão em <code>Demo/Demo.SampleData.pas</code>.</p>
        <div className="integration-subtabs">{relationshipScenarios.map((item) => <button type="button" className={scenario === item.id ? 'active' : ''} onClick={() => setScenario(item.id)} key={item.id}>{item.label}</button>)}</div>
        <div className="scenario-layout"><div className="scenario-explanation"><span>COMO FUNCIONA</span><h4>{selectedScenario.title}</h4><p>{selectedScenario.summary}</p><ol>{selectedScenario.links.map((link) => <li key={link}><code>{link}</code></li>)}</ol></div><CodeBlock onCopy={onCopy} label={`DELPHI · ${selectedScenario.label.toUpperCase()}`}>{selectedScenario.code}</CodeBlock></div>
      </section>

      <section className="integration-section-card"><h3>3. Listar, baixar e percorrer pedidos tipados</h3><p><code>ListarPedidosPendentes</code> devolve a fila. <code>CarregarDetalhePedidoPorID</code> mantém o pedido no componente, permitindo percorrer <code>DetalhePedidos</code>, <code>Itens</code>, <code>Adicionais</code>, <code>Pagamentos</code> e <code>ContasRecebidas</code> sem manipular JSON manualmente.</p><CodeBlock onCopy={onCopy} label="PEDIDOS TIPADOS">{componentOrdersCode}</CodeBlock>
        <div className="integration-callouts"><article><strong>Memória</strong><p>O resultado de <code>ListarPedidosPendentes</code>, <code>EnviarCarga</code>, <code>BaixarPedido...</code> e <code>Confirmar...</code> pertence ao chamador e deve receber <code>Free</code>. O resultado de <code>CarregarDetalhe...</code> pertence ao componente.</p></article><article><strong>Interface responsiva</strong><p>As chamadas são síncronas. Em telas VCL, execute operações demoradas em uma thread e atualize a interface com <code>TThread.Queue</code> ou <code>TThread.Synchronize</code>.</p></article></div>
      </section>

      <section className="integration-section-card"><h3>4. Regra especial dos pagamentos</h3><p>O componente sempre entrega uma coleção de pagamentos utilizável. Quando <code>Pagamento[]</code> chega vazio, ele cria um pagamento a partir de <code>Pedido.ID_CPGTO_CODI</code> e do total financeiro do pedido. A propriedade <code>GeradoDoCabecalho</code> informa essa origem.</p><div className="payment-rule"><span><b>Forma</b><code>Pedido.ID_CPGTO_CODI</code></span><i>+</i><span><b>Valor</b><code>Σ (TOTAL + ACRESCIMO − DESCONTO)</code></span><i>→</i><span><b>Pagamento tipado</b><code>Pedido.Pagamentos[0]</code></span></div><p>A descrição fica disponível em <code>Pagamento.Descricao</code>. O componente procura, nesta ordem: descrição recebida no pagamento, <code>FormaPgto.CPGTO_DESC</code> carregada no componente, rede e, por último, o texto de fallback “Forma de pagamento N”.</p></section>

      <section className="integration-section-card"><span className="eyebrow">ALTERNATIVA BINÁRIA</span><h3>Consumir pela DTVendaAPI.dll</h3><p>Distribua a DLL Win32 junto ao executável. Para Delphi, use o carregador <code>Source/DTVenda.API.Client.pas</code>, que resolve as funções e libera corretamente os textos retornados pela DLL.</p><CodeBlock onCopy={onCopy} label="CLIENTE DELPHI PARA A DLL">{dllCode}</CodeBlock><div className="doc-notes warning"><h3>Compatibilidade e memória</h3><p>A DLL é Win32, Unicode e usa <code>stdcall</code>. Clientes que chamarem os exports diretamente devem liberar todo <code>PWideChar</code> retornado com <code>DTVenda_LiberarTexto</code>. Consulte falhas com <code>DTVenda_UltimoErro</code> e <code>DTVenda_UltimoStatusHTTP</code>.</p></div></section>
    </div>}

    {tab === 'json' && <nav className="integration-subtabs json-section-tabs" aria-label="Conteúdo da documentação JSON"><button type="button" className={jsonView === 'completo' ? 'active' : ''} onClick={() => setJsonView('completo')}>JSON completo comentado</button><button type="button" className={jsonView === 'relacionamentos' ? 'active' : ''} onClick={() => setJsonView('relacionamentos')}>Amarrações e cenários</button><button type="button" className={jsonView === 'carga' ? 'active' : ''} onClick={() => setJsonView('carga')}>Campos da carga</button><button type="button" className={jsonView === 'retorno' ? 'active' : ''} onClick={() => setJsonView('retorno')}>Campos dos pedidos</button></nav>}

    {tab === 'json' && jsonView === 'completo' && <FullJsonGuide onCopy={onCopy}/>}

    {tab === 'json' && jsonView === 'relacionamentos' && <div className="integration-tab-panel">
      <section className="integration-section-card"><span className="eyebrow">MAPA DE AMARRAÇÕES</span><h3>Entenda primeiro quem aponta para quem</h3><p>As relações usam códigos funcionais, principalmente <code>GTIN</code>, e não a posição dos objetos no array. A ordem dos registros não cria vínculo.</p>
        <div className="relationship-grid load-relationships"><span><code>Produtos.GRUPO</code><i>→</i><code>Grupos.CODGRUPO</code><small>produto → grupo de exibição</small></span><span><code>Produtos.IDRECEITA</code><i>→</i><code>Composicao.IDRECEITA</code><small>produto pai → ingredientes/retiradas</small></span><span><code>Composicao.CODIGO</code><i>→</i><code>Produtos.GTIN</code><small>composição → ingrediente</small></span><span><code>ItensAcrescimo.CODPRODUTO</code><i>→</i><code>Produto pai.GTIN</code><small>produto pai → lista de adicionais</small></span><span><code>ItensAcrescimo.CODIGO</code><i>→</i><code>Adicional.GTIN</code><small>adicional → produto cadastrado</small></span><span><code>Opcoesdoitem.CODPRODUTO</code><i>→</i><code>Produto pai.GTIN</code><small>produto pai → opções/sabores</small></span><span><code>Opcoesdoitem.CODOPCAO</code><i>→</i><code>Produto sabor.GTIN</code><small>opção → produto-sabor</small></span><span><code>Clientes.IDPAGPREF</code><i>→</i><code>FormaPgto.CPGTO_CODI</code><small>cliente → forma preferencial</small></span><span><code>PrecoDiferenciado.IDCLI</code><i>→</i><code>Clientes.PES_CODI</code><small>preço especial → cliente</small></span><span><code>PrecoDiferenciado.CODIGO</code><i>→</i><code>Produtos.GTIN</code><small>preço especial → produto</small></span></div>
        <div className="doc-notes warning"><h3>Não crie grupo de ingredientes ou adicionais</h3><p><code>IDCATEGORIA</code> serve apenas para organizar adicionais em seções na interface. Ingredientes, adicionais e sabores precisam existir em <code>Produtos</code>, mas não precisam de registros próprios em <code>Grupos</code>.</p></div>
      </section>
      <section className="integration-section-card"><h3>Visualize cada cenário completo</h3><p>Troque o cenário para conferir exatamente as chaves, os indicadores e o preenchimento tipado equivalente.</p><div className="integration-subtabs">{relationshipScenarios.map((item) => <button type="button" className={scenario === item.id ? 'active' : ''} onClick={() => setScenario(item.id)} key={item.id}>{item.label}</button>)}</div><div className="scenario-layout"><div className="scenario-explanation"><span>REGRA DO CENÁRIO</span><h4>{selectedScenario.title}</h4><p>{selectedScenario.summary}</p><ol>{selectedScenario.links.map((link) => <li key={link}><code>{link}</code></li>)}</ol></div><CodeBlock onCopy={onCopy} label={`EXEMPLO · ${selectedScenario.label.toUpperCase()}`}>{selectedScenario.code}</CodeBlock></div></section>
      <section className="integration-section-card"><h3>Relacionamentos quando o pedido volta</h3><p>Essas chaves reconstroem a venda recebida. O pagamento pertence ao pedido inteiro, não a um item.</p><div className="relationship-grid"><span><code>Pedido.CODIGO</code><i>→</i><code>Item.ID_VENDA</code><small>pedido → itens</small></span><span><code>Item.ID</code><i>→</i><code>Adicional.IDITEM</code><small>item → adicionais</small></span><span><code>Pedido.CODIGO</code><i>→</i><code>Pagamento.NPV</code><small>pedido → pagamentos</small></span><span><code>Pagamento.IDFORMA</code><i>→</i><code>FormaPgto.CPGTO_CODI</code><small>descrição da forma</small></span><span><code>Pedido.CODIGO</code><i>→</i><code>ContaRecebida.PEDIDO</code><small>pedido → conta recebida</small></span></div><div className="envelope-note"><strong>Conferência financeira</strong><span>Em cada item, <code>TOTAL</code> é o subtotal. Calcule <code>TOTAL + ACRESCIMO - DESCONTO</code> e some os itens. O resultado deve coincidir com a soma de <code>Pagamento.VALOR</code>.</span></div></section>
    </div>}

    {tab === 'json' && jsonView === 'carga' && <div className="integration-tab-panel">
      <section className="integration-section-card"><span className="eyebrow">PASSO 1 · ENVIO DE DADOS</span><h3>Publicar a carga do ERP</h3><p>Envie <code>Dados.json</code> para <code>POST /carga-dados</code>. O envelope tem <code>nome_arquivo</code> e <code>dados</code>; os 14 arrays ficam diretamente dentro de <code>dados</code>.</p>
        <CodeBlock onCopy={onCopy} label="REQUISIÇÃO COMPLETA">{postLoad}</CodeBlock>
        <div className="envelope-note"><strong>Um único <code>dados</code></strong><span><code>body.dados</code> é o conteúdo do arquivo e recebe os 14 arrays diretamente (<code>body.dados.Clientes</code>, <code>body.dados.Produtos</code>…). Não crie uma segunda raiz <code>dados</code> dentro dele.</span></div>
      </section>
      <section className="integration-section-card"><h3>Estrutura do conteúdo de <code>Dados.json</code></h3><p>Os 14 arrays ficam na raiz do arquivo. Os nomes são sensíveis a maiúsculas e minúsculas.</p><CodeBlock onCopy={onCopy} label="CONTEÚDO DO ARQUIVO">{loadRoot}</CodeBlock></section>
      <section className="integration-section-card"><h3>Dicionário da carga e exemplos por conjunto</h3><p>Todas as listas da carga devem existir no JSON. <code>Clientes</code>, <code>Produtos</code>, <code>FormaPgto</code>, <code>Vendedores</code>, <code>Grupos</code> e <code>AliqUF</code> precisam ter conteúdo; as demais podem ser enviadas vazias, como <code>[]</code>. A carga pode ser enviada antes da ativação do aplicativo, exceto com aplicativo ou cliente inativo ou bloqueado.</p><p><strong>Sim</strong> significa que o campo deve existir, mesmo com <code>""</code> ou <code>0</code>. <strong>Não</strong> significa que há leitura tolerante ou valor padrão. Abra cada conjunto para consultar seus campos e um objeto de exemplo pronto.</p><DatasetDictionary datasets={loadDatasets} search={loadSearch} setSearch={setLoadSearch} examples={loadExamples} onCopy={onCopy}/></section>
      <section className="integration-section-card complete-json-example"><span className="eyebrow">EXEMPLO INTEGRADO</span><h3><code>Dados.json</code> completo e preenchido</h3><p>Este exemplo contém um registro realista em cada um dos 14 arrays. Os identificadores foram montados de forma coerente para demonstrar os relacionamentos. CNPJ, CPF, inscrições e credenciais são apenas dados fictícios de documentação.</p><CodeBlock onCopy={onCopy} label="CONTEÚDO COMPLETO DE DADOS.JSON">{completeLoadJson}</CodeBlock></section>
      <section className="integration-section-card complete-json-example"><h3>Requisição completa pronta para teste</h3><p>Além do conteúdo do arquivo, esta versão mostra exatamente o envelope HTTP esperado por <code>POST /carga-dados</code>.</p><CodeBlock onCopy={onCopy} label="POST COM TODOS OS EXEMPLOS">{postCompleteLoad}</CodeBlock></section>
      <section className="integration-section-card complete-json-example"><h3>Como a carga chega ao aplicativo</h3><p>Ao consultar <code>GET /carga-dados?nome_arquivo=Dados.json</code>, o aplicativo recebe o envelope abaixo. Os 14 arrays importáveis estão diretamente em <code>arquivo.dados</code>.</p><CodeBlock onCopy={onCopy} label="RESPOSTA COMPLETA DA API">{completeLoadResponse}</CodeBlock></section>
      <section className="doc-notes"><h3>Checklist antes de publicar</h3><ol><li>Gerar JSON válido em UTF-8 com os 14 arrays diretamente em <code>dados</code>, sem uma segunda raiz <code>dados</code>.</li><li>Incluir os 14 arrays com os nomes exatos; usar <code>[]</code> quando vazios, exceto em <code>Clientes</code>, <code>Produtos</code>, <code>FormaPgto</code>, <code>Vendedores</code>, <code>Grupos</code> e <code>AliqUF</code>, que precisam ter conteúdo.</li><li>Enviar <code>Vendedores.NOME</code> e <code>Vendedores.SENHA</code> em <strong>LETRAS MAIÚSCULAS</strong>.</li><li>Preencher todos os campos obrigatórios sem <code>null</code>.</li><li>Usar números JSON reais, ponto decimal e datas <code>DD/MM/AAAA</code>.</li><li>Enviar <code>Produtos.imagem</code> exatamente em minúsculas; use <code>""</code> sem imagem.</li><li>Garantir que <code>Clientes.IDPAGPREF</code>, se informado, exista em <code>FormaPgto.CPGTO_CODI</code>.</li><li>Validar referências e o arquivo inteiro antes de substituir a carga publicada.</li></ol></section>
    </div>}

    {tab === 'json' && jsonView === 'retorno' && <div className="integration-tab-panel">
      <section className="integration-section-card"><span className="eyebrow">PASSO 2 · DADOS DO APLICATIVO</span><h3>Pedidos e contas recebidas</h3><p>O aplicativo produz um objeto com <code>Pedidos</code> e <code>ContasRecebidas</code>. Para armazená-lo no portal, envie esse objeto na propriedade externa <code>pedidos</code> de <code>POST /pedidos</code>.</p><CodeBlock onCopy={onCopy} label="REQUISIÇÃO COMPLETA">{postOrders}</CodeBlock>
        <div className="envelope-note"><strong>Tipos no retorno do aplicativo</strong><span>O gerador usa <code>SELECT *</code>: envia todas as colunas existentes no banco local. Textos são strings; inteiros e decimais são números; datas e outros tipos são convertidos para texto conforme a configuração regional do aparelho. Por isso, o ERP deve fazer leitura tolerante a colunas adicionais.</span></div>
      </section>
      <section className="integration-section-card"><h3>Estrutura gerada pelo aplicativo</h3><CodeBlock onCopy={onCopy} label="CONTEÚDO DE PEDIDOS">{appJson}</CodeBlock></section>
      <PagamentoPorModo/>
      <section className="integration-section-card"><h3>Dicionário do retorno e exemplos por nível</h3><p>Os campos são gerados pelo aplicativo a partir das tabelas locais. Os nomes aninhados <code>itens</code>, <code>Adicionais</code> e <code>Pagamento</code> devem ser respeitados exatamente. Abra cada nível para ver um objeto realista isolado.</p><DatasetDictionary datasets={appDatasets} search={appSearch} setSearch={setAppSearch} examples={appExamples} onCopy={onCopy}/></section>
      <section className="doc-notes"><h3>Onde consultar as amarrações</h3><p>Use a opção <strong>Amarrações e cenários</strong> acima para visualizar as chaves do pedido e os exemplos completos de retirada, adicionais, pizza e açaí.</p></section>
      <section className="doc-notes"><h3>Como importar com segurança</h3><ul><li>Trate arrays vazios como resultado válido.</li><li>Faça a importação do pedido e seus filhos em uma transação no ERP.</li><li>Use as chaves de relacionamento do próprio JSON para associar itens, adicionais e pagamentos.</li><li>Aceite campos adicionais para manter compatibilidade com novas versões do aplicativo.</li><li>Só confirme a sincronização depois de gravar todos os dados com sucesso.</li></ul></section>
    </div>}

    {tab === 'api' && <div className="integration-tab-panel">
      <section className="doc-notes warning"><h3>Regra do ambiente de homologação</h3><p>Cada Software House recebe automaticamente o <strong>CLIENTE HOMOLOGACAO</strong> e o <strong>APP Homologação</strong>, identificado por um token iniciado com <code>DEMO</code>. Esse aplicativo aceita cargas com no máximo <strong>10 produtos</strong>. Acima desse limite, a API responde HTTP 400 com o código <code>DEMO_PRODUCT_LIMIT</code>. O cliente e o aplicativo não podem ser excluídos. No aplicativo, apenas a descrição “APP Homologação” é fixa; as demais configurações podem ser alteradas.</p></section>
      <section className="integration-section-card"><span className="eyebrow">FLUXO COMPLETO</span><h3>Enviar a carga e receber os pedidos</h3><p>Escolha como sua aplicação fará a integração. Nos dois modos, o token é o token individual do aplicativo e a confirmação acontece somente depois que o ERP gravar tudo com sucesso.</p><div className="integration-subtabs"><button type="button" className={apiView === 'direta' ? 'active' : ''} onClick={() => setApiView('direta')}>API HTTP direta</button><button type="button" className={apiView === 'componente' ? 'active' : ''} onClick={() => setApiView('componente')}>Componente TDTVenda</button></div>
        {apiView === 'direta' && <div className="api-guide-grid"><article><span>ETAPA 1</span><h4>Publicar a carga</h4><p>Monte o envelope com <code>nome_arquivo</code> e <code>dados</code>, envie para <code>POST /carga-dados</code> e valide <code>success: true</code>.</p><CodeBlock onCopy={onCopy} label="HTTP · ENVIO DA CARGA">{postLoad}</CodeBlock></article><article><span>ETAPAS 2 A 4</span><h4>Receber e confirmar pedidos</h4><p>Liste apenas pendentes, baixe o conteúdo, importe em transação e confirme pelo ID.</p><CodeBlock onCopy={onCopy} label="HTTP · CICLO DOS PEDIDOS">{directOrdersCode}</CodeBlock></article></div>}
        {apiView === 'componente' && <div className="api-guide-grid"><article><span>CARGA TIPADA</span><h4>O componente gera e envia o JSON</h4><p>Alimente as coleções, confira com <code>GerarEnvelopeJSON</code> e use <code>EnviarCarga</code>. Não é necessário montar cabeçalhos ou URLs manualmente.</p><CodeBlock onCopy={onCopy} label="TDTVENDA · CARGA E PEDIDOS">{componentApiCode}</CodeBlock></article><article className="api-checklist"><span>RETORNO TIPADO</span><h4>O que fica disponível</h4><ul><li><code>DetalhePedidos</code> para cada venda.</li><li><code>Pedido.Itens</code> e <code>Item.Adicionais</code>.</li><li><code>Pedido.Pagamentos</code> com descrição e fallback do cabeçalho.</li><li><code>ContasRecebidas</code> no nível do arquivo.</li><li><code>ConfirmarPedido</code> após o COMMIT.</li></ul></article></div>}
      </section>
      <div className="endpoint-list">
        <article><div><span className="method post">POST</span><code>/carga-dados</code></div><h3>Publicar ou atualizar a carga</h3><p>Recebe <code>nome_arquivo</code> e <code>dados</code>. Repetir o mesmo nome atualiza o arquivo existente.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "message": "Dados de carga recebidos com sucesso"\n}`}</CodeBlock></article>
        <article><div><span className="method get">GET</span><code>/carga-dados?nome_arquivo=dados.json</code></div><h3>Baixar a carga publicada</h3><p>O aplicativo usa esta rota para obter o arquivo mais recente pelo nome.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "arquivo": {\n    "nome": "dados.json",\n    "dados": { "Clientes": [], "Produtos": [] },\n    "data_atualizacao": "2026-08-31T17:30:00.000Z"\n  }\n}`}</CodeBlock></article>
        <article><div><span className="method post">POST</span><code>/pedidos</code></div><h3>Aplicativo envia pedidos</h3><p>Recebe <code>nome_arquivo</code> e <code>pedidos</code>, contendo o contrato gerado pelo aplicativo.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "message": "Pedidos recebidos com sucesso"\n}`}</CodeBlock></article>
        <article><div><span className="method get">GET</span><code>/app/pedidos-pendentes</code></div><h3>Listar a fila pendente</h3><p>Retorna apenas metadados. Use o <code>id</code> para baixar o conteúdo completo.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "total": 1,\n  "pedidos": [{\n    "id": 123,\n    "nome_arquivo": "pedidos_20260831.json",\n    "data_recebimento": "2026-08-31T17:30:00.000Z",\n    "status": "Pendente"\n  }]\n}`}</CodeBlock></article>
        <article><div><span className="method get">GET</span><code>/app/pedidos/download?id=123</code></div><h3>Baixar o JSON completo</h3><p>Aceita <code>id</code> ou <code>nome_arquivo</code> na query string. O pagamento vem em <code>Pagamento[]</code> no modo PDV e em <code>ID_CPGTO_CODI</code> na força de vendas; veja o aviso abaixo.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "pedido": {\n    "id": 123,\n    "nome_arquivo": "pedidos_20260831.json",\n    "data_recebimento": "2026-08-31T17:30:00.000Z",\n    "status": "Pendente",\n    "dados": { "Pedidos": [], "ContasRecebidas": [] }\n  }\n}`}</CodeBlock></article>
        <article><div><span className="method put">PUT</span><code>/app/pedidos/sincronizar</code></div><h3>Confirmar a importação</h3><p>Envie uma das opções: <code>{'{ "id": 123 }'}</code>, <code>{'{ "ids": [123, 124] }'}</code> ou <code>{'{ "nome_arquivo": "arquivo.json" }'}</code>.</p><CodeBlock onCopy={onCopy} label="RESPOSTA 200">{`{\n  "success": true,\n  "message": "2 pedido(s) sincronizado(s) com sucesso",\n  "total_sincronizados": 2\n}`}</CodeBlock></article>
      </div>
      <PagamentoPorModo/>
      <section className="integration-section-card"><h3>Códigos HTTP e erros</h3><div className="http-status-grid"><span><b>200</b><p>Operação concluída. Confirme também <code>success: true</code>.</p></span><span><b>400</b><p>Campo, ID ou nome de arquivo obrigatório não informado, ou carga incompleta (<code>CARGA_INVALIDA</code>).</p></span><span><b>401</b><p>Token ausente, inválido ou aplicativo inativo.</p></span><span><b>403</b><p>Acesso indisponível ou dispositivo não vinculado. Exiba o campo <code>message</code>, que traz o telefone de suporte da Software House.</p></span><span><b>404</b><p>Arquivo ou pedido não encontrado.</p></span><span><b>500</b><p>Falha interna. Não confirme a sincronização; registre e tente novamente.</p></span></div>
        <CodeBlock onCopy={onCopy} label="FORMATO DE ERRO">{`{\n  "success": false,\n  "error": "Descrição do erro"\n}`}</CodeBlock>
      </section>
      <section className="integration-resource-card"><div><span className="eyebrow">TESTE E HOMOLOGAÇÃO</span><h3>Leve o fluxo do ERP para o Postman</h3><p>Depois de importar, preencha somente <code>baseUrl</code> e <code>apiToken</code>. A collection contém carga, listagem, download e confirmação, e salva automaticamente o primeiro pedido pendente em <code>pedidoId</code>.</p></div><div className="integration-resource-actions"><a className="resource-button primary" href="/downloads/DTVenda-Carga-Pedidos.postman_collection.json" download>Baixar collection</a><button className="resource-button" type="button" onClick={() => onCopy(base)}>Copiar URL base</button></div></section>
      <section className="doc-notes warning"><h3>Regra de confirmação</h3><p>Nunca marque um pedido como sincronizado antes de concluir a gravação no ERP. Em caso de falha parcial, mantenha-o pendente e faça a nova tentativa de forma idempotente, usando o ID do portal ou a chave do pedido para impedir duplicidades.</p></section>
    </div>}
  </div>;
}
